const actionPlanRoutes = [
  {
    path: "/action_plans",
    name: "ActionPlanIndex",
    component: () => import("@/_action-plan/pages/IndexActionPlan.vue"),
    // component: () => import("@/_action-plan/pages/ActionPlans.vue"),
    meta: {
      translated: "Planos de Ação",
      auth: true,
      permission: { act: "read", on: "User" },
    },
    // children: [
    //   {
    //     path: "kanban",
    //     name: "ActionPlanKanban",
    //     component: () => import("@/_action-plan/pages/ActionPlanKanban.vue"),
    //     // component: () => import("@/_action-plan/pages/ActionPlans.vue"),
    //     meta: {
    //       translated: "Planos de Ação",
    //       auth: true,
    //       permission: { act: "read", on: "User" },
    //     },
    //   },
    // ]
  },
  {
    path: "/one-action-plan/:id",
    name: "OneActionPlan",
    component: () => import("@/_action-plan/pages/OneActionPlan.vue"),
    meta: {
      auth: true,
      permission: { act: "read", on: "User" },
    },
  },
  {
    path: "/new-action-plan",
    name: "NewActionPlan",
    component: () => import("@/_action-plan/pages/NewActionPlan.vue"),
    meta: {
      translated: "Novo Plano de Ação",
      auth: true,
      permission: { act: "read", on: "User" },
    },
  },
];

export default actionPlanRoutes;
